import React from "react";
import Secheader from "../pages/common/Secondaryheader";
import servicesData from "../data/ServicesData"; // Import your data file
import { NavLink, useParams } from "react-router-dom"; // Import useParams

const ServiceDetails = () => {
  const { serviceId } = useParams(); // Get the serviceId from the URL parameter

  // Convert the string serviceId to a number
  const serviceIndex = parseInt(serviceId, 10);

  // Check if serviceIndex is valid
  if (
    isNaN(serviceIndex) ||
    serviceIndex < 0 ||
    serviceIndex >= servicesData.length
  ) {
    return (
      <>
        <Secheader
          sectitle="Services"
          secdesc="Empower. Innovate. ByteSkull."
        />

        <section>
          <div className="container mx-auto py-5 col-lg-10 col-xl-9 text-center">
            <div className="mb-5">
              <p className="display-6 mb-1">Service not found</p>
            </div>
            <NavLink className="nav-link" to="/service">
              <button className="btn p-2 btn_custom col-lg-3 col-md-5 col-6">
                Back
              </button>
            </NavLink>
          </div>
        </section>
      </>
    );
  }

  const service = servicesData[serviceIndex];

  return (
    <>
      <Secheader sectitle="Services" secdesc="Empower. Innovate. ByteSkull." />

      <section>
        <div className="container mx-auto py-5 col-lg-10 col-xl-9">
          <div className="mb-5 text-center">
            <h1 className="display-6 mb-1">{service.title}</h1>
          </div>
          <div className="col-lg-6 col-xl-6 mb-4 text-center mx-auto">
            <img src={service.image} className="img-fluid" alt="Responsive"/>
          </div>

          <p>{service.intro}</p>

          {/* Render the approach and deliverables sections */}
          <div className="mb-4">
            <h2>Approach:</h2>
            <ul>
              {service.approach.map((item, index) => (
                <li key={index}>{item}</li>
                ))}
            </ul>
          </div>
          <div className="mb-4">
            <h2>Deliverables:</h2>
            <ul>
              {service.deliverables.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="mb-4">
            <h2>Portfolio:</h2>
            <p>{service.portfolio}</p>
          </div>
          <div className="mb-4">
            <h2>Conclusion:</h2>
            <p>{service.conclusion}</p>
          </div>

        </div>

        <div className="container d-flex justify-content-center align-items-center">
          <div className="col-12 col-md-9 col-lg-6 py-5 text-center">
            <NavLink className="nav-link" to="/service">
              <button className="btn p-2 btn_custom col-lg-3 col-md-5 col-6">
                Back
              </button>
            </NavLink>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiceDetails;
